import api from "!../../../../../../npm/.store/sdx_programmablesurfaces/style-loader@2.0.0-fa7288d0791a59a140e0/node_modules/style-loader/dist/runtime/injectStylesIntoStyleTag.js";
            import content from "!!../../../../../../npm/.store/sdx_programmablesurfaces/css-loader@5.2.7-96a7d86de4bae6cce5d6/node_modules/css-loader/dist/cjs.js!./index.css";

var options = {};

options.insert = "head";
options.singleton = false;

var update = api(content, options);



export default content.locals || {};